export function getUniqueList(list) {
  return [ ...new Set(list) ]
}